/**
 * Направления деятельности — формулировки соответствуют видам работ,
 * указанным в ЕГРЮЛ. Порядок и состав менять только вместе с ОКВЭД.
 */

const services = [
  {
    slug: 'razrabotka-po',
    title: 'Разработка компьютерного программного обеспечения',
    tag: 'Разработка ПО',
    short: 'Веб-сервисы, внутренние системы и интеграции под задачу заказчика.',
  },
  {
    slug: 'konsalting',
    title: 'Деятельность консультативная и работы в области компьютерных технологий',
    tag: 'Консалтинг',
    short: 'Аудит, техническая экспертиза и сопровождение решений.',
  },
  {
    slug: 'proektirovanie',
    title: 'Планирование и проектирование компьютерных систем',
    tag: 'Проектирование',
    short: 'Архитектура, техническое задание и план внедрения.',
  },
  {
    slug: 'vvod-v-ekspluataciyu',
    title: 'Подготовка компьютерных систем к эксплуатации',
    tag: 'Ввод в эксплуатацию',
    short: 'Развёртывание, настройка и обучение пользователей.',
  },
  {
    slug: 'soprovozhdenie',
    title: 'Сопровождение компьютерных систем',
    tag: 'Сопровождение',
    short: 'Поддержка, доработки и регламентное обслуживание.',
  },
  {
    slug: 'prochie-it-uslugi',
    title: 'Деятельность, связанная с использованием вычислительной техники и информационных технологий, прочая',
    tag: 'Прочие ИТ-услуги',
    short: 'Настройка и применение информационных технологий для решения задач бизнеса.',
  },
  {
    slug: 'obrabotka-dannyh',
    title: 'Деятельность по обработке данных, предоставление услуг по размещению информации и связанная с этим деятельность',
    tag: 'Обработка данных',
    short: 'Обработка данных и размещение информации в информационных системах.',
  },
  {
    slug: 'bazy-dannyh',
    title: 'Деятельность по созданию и использованию баз данных и информационных ресурсов',
    tag: 'Базы данных',
    short: 'Создание, ведение и использование баз данных и информационных ресурсов.',
  },
  {
    slug: 'nauchnye-issledovaniya',
    title: 'Научные исследования и разработки в области естественных и технических наук прочие',
    tag: 'Исследования и разработки',
    short: 'Научно-исследовательские и опытно-конструкторские работы в технических областях.',
  },
  {
    slug: 'reklamnaya-deyatelnost',
    title: 'Деятельность рекламных агентств',
    tag: 'Реклама',
    short: 'Разработка и сопровождение рекламных кампаний и материалов.',
  },
  {
    slug: 'dopolnitelnoe-obrazovanie',
    title: 'Образование дополнительное детей и взрослых',
    tag: 'Дополнительное образование',
    short: 'Дополнительные образовательные программы для детей и взрослых.',
  },
  {
    slug: 'professionalnoe-obrazovanie',
    title: 'Образование профессиональное дополнительное',
    tag: 'Профессиональное образование',
    short: 'Программы повышения квалификации и профессиональной переподготовки.',
  },
];

export default services;
